import { common as arCommon } from './ar/common';
import { common as enCommon } from './en/common';

export const resources = {
  ar: {
    common: arCommon,
  },
  en: {
    common: enCommon,
  },
};